import React from "react";
import PropTypes from "prop-types";
import { Grid, CircularProgress, Typography } from "@material-ui/core";
import NumericDataBlock from "../../../../../../app/components/NumericDataBlock";
import { translate as t } from "../../../../../../infrastructure/translate/localization";
import PieChartBlock from "../../../../../../app/components/PieChartBlock";
import useStyles from "./styles";
import SearchableFilter from "../../../../../../app/components/SearchableFilter";
import { displayConsumptionsBlock } from "../../../../displays/display-consumptions-block";
import { ReactComponent as EmptyListIllustration } from "../../../../../../assets/img/empty-list.svg";

export default function ConsumptionsBlock({
  monthlyConsumptionsData,
  consumptionsPerPersonData,
  consumptionsData,
  currentFilters,
  isLoading,
}) {
  const { filter, filtersContainer, pieContainer, spinner, svg } = useStyles();

  return (
    <>
      <Grid item xs={12} container className={filtersContainer}>
        {/* consumptionsData?.availableBalances?.length > 0 && (
          <SearchableFilter
            disabled={isLoading}
            className={filter}
            options={consumptionsData?.availableBalances.map((item) => {
              const formattedDate = moment(item).format("MMMM YYYY");
              return {
                name:
                  formattedDate.charAt(0).toUpperCase() +
                  formattedDate.slice(1),
                id: item,
              };
            })}
            placeholder={t("analytics-section.payroll-cycle")}
            onChange={(value) => {
              displayConsumptionsBlock({
                filters: { ...currentFilters, endPayroll: value },
              });
            }}
          />
        ) */}
        <SearchableFilter
          disabled={isLoading}
          className={filter}
          options={consumptionsData?.models}
          placeholder={t("common-messages.benefit-model")}
          onChange={(value) => {
            displayConsumptionsBlock({
              filters: { ...currentFilters, benefitId: value },
            });
          }}
        />
      </Grid>
      {consumptionsData?.data?.byBenefitType?.monthly.length > 0 ? (
        <>
          <Grid container direction="row" spacing={5}>
            <Grid item xs={6}>
              <NumericDataBlock
                isLoading={isLoading}
                title={t("analytics-section.monthly-consumption")}
                {...monthlyConsumptionsData}
              />
            </Grid>
            <Grid item xs={6}>
              <NumericDataBlock
                isLoading={isLoading}
                title={t("analytics-section.consumptions-per-person")}
                {...consumptionsPerPersonData}
              />
            </Grid>
          </Grid>
          <Grid container spacing={5}>
            <Grid
              item
              container
              xs={6}
              justify="center"
              alignItems="center"
              className={pieContainer}
            >
              {!isLoading ? (
                <PieChartBlock
                  data={consumptionsData?.data?.byBenefitType?.monthly}
                  currency={consumptionsData?.currency}
                />
              ) : (
                <CircularProgress className={spinner} />
              )}
            </Grid>
            <Grid
              item
              container
              xs={6}
              justify="center"
              alignItems="center"
              className={pieContainer}
            >
              {!isLoading ? (
                <PieChartBlock
                  data={consumptionsData?.data?.byBenefitType?.perPerson}
                  currency={consumptionsData?.currency}
                />
              ) : (
                <CircularProgress className={spinner} />
              )}
            </Grid>
          </Grid>
        </>
      ) : (
        <Grid item xs={12}>
          <Grid item container xs={12} justify="center">
            <EmptyListIllustration className={svg} />
          </Grid>
          <Grid item container xs={12} justify="center">
            <Typography variant="body1" align="center">
              {t("common-messages.there-are-no-consumptions")}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
}

ConsumptionsBlock.defaultProps = {
  monthlyConsumptionsData: {},
  consumptionsPerPersonData: {},
  consumptionsData: undefined,
  currentFilters: {},
  isLoading: false,
};

ConsumptionsBlock.propTypes = {
  monthlyConsumptionsData: PropTypes.object,
  consumptionsPerPersonData: PropTypes.object,
  consumptionsData: PropTypes.object,
  currentFilters: PropTypes.object,
  isLoading: PropTypes.bool,
};
